import LocationInfoSFC from "./LocationInfo.vue";
export const LocationInfo = LocationInfoSFC;
